import styled, { css } from "styled-components";
import { type AlertSeverity } from "@boi/components-core";
import { useDesignTokens, parseSizeToken } from "@boi/react-design-tokens";

type ContainerProps = {
  $severity: AlertSeverity;
};

export const Container = styled.div<ContainerProps>`
  ${({ $severity }) => {
    const { tokens } = useDesignTokens();
    const { alert } = tokens;

    return css`
      display: grid;
      grid-template-columns: 1fr;
      grid-auto-flow: column;
      gap: ${alert.gap};
      border-radius: ${alert.radius};
      border-top-width: ${alert.stroke.width.top};
      border-left-width: ${alert.stroke.width.left};
      border-right-width: ${alert.stroke.width.right};
      border-bottom-width: ${alert.stroke.width.bottom};
      border-style: ${alert.stroke.style};
      border-color: ${alert.stroke.color[$severity]};
      padding-top: ${alert.padding.top};
      padding-left: ${alert.padding.left};
      padding-right: ${alert.padding.right};
      padding-bottom: ${alert.padding.bottom};
      background-color: ${alert.background[$severity]};
    `;
  }}
`;

type ContentContainerProps = {
  $isDismissible: boolean;
};

export const ContentContainer = styled.div<ContentContainerProps>`
  ${({ $isDismissible }) => {
    const { tokens } = useDesignTokens();
    const { alert } = tokens;

    return [
      css`
        display: grid;
        grid-template-columns: auto 1fr;
        gap: ${alert.contentContainer.gap};
        padding-top: ${alert.contentContainer.padding.top};
        padding-left: ${alert.contentContainer.padding.left};
        padding-right: ${alert.contentContainer.padding.right.default};
        padding-bottom: ${alert.contentContainer.padding.bottom};
      `,
      $isDismissible &&
        css`
          padding-right: ${alert.contentContainer.padding.right.dismissible};
        `,
    ];
  }}
`;

type IconWrapperProps = {
  $severity: AlertSeverity;
};

export const IconWrapper = styled.div<IconWrapperProps>`
  ${({ $severity }) => {
    const { tokens } = useDesignTokens();
    const { alert } = tokens;

    return css`
      display: grid;
      place-items: center;
      height: ${parseSizeToken(alert.iconWrapper.height)};

      svg {
        display: block;
        width: ${alert.icon.width};
        height: ${alert.icon.height};

        & [data-primary-color] {
          color: ${alert.icon.primaryColor[$severity]};
        }

        & [data-secondary-color] {
          color: ${alert.icon.secondaryColor[$severity]};
        }
      }
    `;
  }}
`;

export const TextContainer = styled.div`
  overflow-wrap: anywhere;
`;

type CloseIconButtonWrapperProps = {
  $hasBody: boolean;
};

export const CloseIconButtonWrapper = styled.div<CloseIconButtonWrapperProps>`
  ${({ $hasBody }) => {
    return css`
      align-self: ${$hasBody ? "start" : "center"};
    `;
  }}
`;
